

export enum AttachFileMode {
    VIEW                 = 'view',
    VIEW_SMALL           = 'view-small',

    VIEW_AND_EDIT        = 'view-and-edit',
    VIEW_AND_EDIT_SMALL  = 'view-and-edit-small',

    EDIT                 = 'edit',
    EDIT_SMALL           = 'edit-small',

    EDIT_IN_EDITOR       = 'edit-in-editor',
    EDIT_IN_EDITOR_SMALL = 'edit-in-editor-small',

    VIEW_IN_EDITOR       = 'view-in-editor',
    VIEW_IN_EDITOR_SMALL = 'view-in-editor-small',
}
